import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HeatmapComponent } from './heatmap.component';


const routes: Routes = [
  { path: 'map', component: HeatmapComponent,  pathMatch : 'full' },
  { path: '**', redirectTo : 'map' }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HeatmapRoutingModule { }
